module.exports = __webpack_public_path__ + "img/79200.1b90be2e.jpg";